module.exports = __webpack_public_path__ + "static/media/diners.628e741f.svg";